import sortByKey from 'utils/sortByKey';
import { slugifyArray } from 'utils/url';

export default class QueryBuilder {
  campaigns;

  entry;

  sort;

  filters;

  customFilters;

  price;

  hideOOS;

  showOOS;

  clusterPath;

  showAllFavourites;

  withCampaigns(campaigns) {
    if (campaigns && campaigns.length) {
      this.campaigns = slugifyArray(sortByKey(campaigns, 'id'));
    }
    return this;
  }

  withSearchTerm(searchTerm) {
    if (searchTerm) {
      this.entry = searchTerm;
    }
    return this;
  }

  withSort(sort) {
    if (sort) {
      this.sort = sort;
    }
    return this;
  }

  withFilters(filters) {
    if (filters && filters.length) {
      this.filters = slugifyArray(sortByKey(filters, 'id'));
    }
    return this;
  }

  withCustomFilters(customFilters) {
    if (customFilters && customFilters.length) {
      this.customFilters = slugifyArray(sortByKey(customFilters, 'id'));
    }
    return this;
  }

  withPriceFilters(priceFilters) {
    if (priceFilters && priceFilters.length) {
      this.price = sortByKey(priceFilters, 'from')
        .map(price => `${price.from}-${(price.to || '')}`)
        .join(',');
    }

    return this;
  }

  withHiddenOOS(hiddenOOS) {
    if (hiddenOOS) {
      this.hideOOS = hiddenOOS;
    }
    return this;
  }

  withShownOOS(shownOOS) {
    if (shownOOS) {
      this.showOOS = shownOOS;
    }
    return this;
  }

  withCluster(cluster) {
    if (cluster && cluster.length) {
      this.clusterPath = slugifyArray(cluster);
    }
    return this;
  }

  withShowAllFavourites(showAllFavourites, condition) {
    if (showAllFavourites && condition) {
      this.showAllFavourites = true;
    }
    return this;
  }

  build() {
    const {
      campaigns,
      entry,
      sort,
      filters,
      customFilters,
      price,
      hideOOS,
      showOOS,
      clusterPath,
      showAllFavourites,
    } = this;
    const result = {
      campaigns,
      entry,
      sort,
      filters,
      customFilters,
      price,
      hideOOS,
      showOOS,
      clusterPath,
      showAllFavourites,
    };
    return JSON.parse(JSON.stringify(result));
  }
}
